import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Component from '../../components/main/Banner';
import { handleBannerListRequest } from '../../redux/action/product.action';

export default function Banner() {
  const dispatch = useDispatch();

  useEffect(() => {
    function success() {}
    function failure() {}

    dispatch(handleBannerListRequest(success, failure));
  }, []);

  return <Component />;
}
